// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/alert_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Alert, AlertStatus } from "./alert_pb";
import { file_inventory_v1_alert } from "./alert_pb";
import type { RiskLevel } from "./risk_pb";
import { file_inventory_v1_risk } from "./risk_pb";
import type { SignalDetail } from "./signal_detail_pb";
import { file_inventory_v1_signal_detail } from "./signal_detail_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/alert_service.proto.
 */
export const file_inventory_v1_alert_service: GenFile = /*@__PURE__*/
  fileDesc("CiBpbnZlbnRvcnkvdjEvYWxlcnRfc2VydmljZS5wcm90bxIMaW52ZW50b3J5LnYxIq4BChFMaXN0QWxlcnRzUmVxdWVzdBIXCgpjb21wYW55X2lkGAEgASgJSACIAQESKwoKc2V2ZXJpdGllcxgCIAMoDjIXLmludmVudG9yeS52MS5SaXNrTGV2ZWwSMAoNd29ya19zdGF0dXNlcxgDIAMoDjIZLmludmVudG9yeS52MS5BbGVydFN0YXR1cxISCgpjb3VudF9vbmx5GAQgASgIQg0KC19jb21wYW55X2lkIlgKEkxpc3RBbGVydHNSZXNwb25zZRIjCgZhbGVydHMYASADKAsyEy5pbnZlbnRvcnkudjEuQWxlcnQSHQoVb3Blbl9vcl9vbmdvaW5nX2NvdW50GAIgASgFIh0KD0dldEFsZXJ0UmVxdWVzdBIKCgJpZBgBIAEoCSJiChBHZXRBbGVydFJlc3BvbnNlEiIKBWFsZXJ0GAEgASgLMhMuaW52ZW50b3J5LnYxLkFsZXJ0EioKBmRldGFpbBgCIAEoCzIaLmludmVudG9yeS52MS5TaWduYWxEZXRhaWwicwoYVXBkYXRlQWxlcnRTdGF0dXNSZXF1ZXN0EgoKAmlkGAEgASgJEikKBnN0YXR1cxgCIAEoDjIZLmludmVudG9yeS52MS5BbGVydFN0YXR1cxIUCgdjb21tZW50GAMgASgJSACIAQFCCgoIX2NvbW1lbnQiGwoZVXBkYXRlQWxlcnRTdGF0dXNSZXNwb25zZSJ2ChtVcGRhdGVNYW51YWxTZXZlcml0eVJlcXVlc3QSCgoCaWQYASABKAkSKQoIc2V2ZXJpdHkYAiABKA4yFy5pbnZlbnRvcnkudjEuUmlza0xldmVsEhQKB2NvbW1lbnQYAyABKAlIAIgBAUIKCghfY29tbWVudCIeChxVcGRhdGVNYW51YWxTZXZlcml0eVJlc3BvbnNlMo0DCgxBbGVydFNlcnZpY2USVAoKTGlzdEFsZXJ0cxIfLmludmVudG9yeS52MS5MaXN0QWxlcnRzUmVxdWVzdBogLmludmVudG9yeS52MS5MaXN0QWxlcnRzUmVzcG9uc2UiA5ACARJOCghHZXRBbGVydBIdLmludmVudG9yeS52MS5HZXRBbGVydFJlcXVlc3QaHi5pbnZlbnRvcnkudjEuR2V0QWxlcnRSZXNwb25zZSIDkAIBEmYKEVVwZGF0ZUFsZXJ0U3RhdHVzEiYuaW52ZW50b3J5LnYxLlVwZGF0ZUFsZXJ0U3RhdHVzUmVxdWVzdBonLmludmVudG9yeS52MS5VcGRhdGVBbGVydFN0YXR1c1Jlc3BvbnNlIgASbwoUVXBkYXRlTWFudWFsU2V2ZXJpdHkSKS5pbnZlbnRvcnkudjEuVXBkYXRlTWFudWFsU2V2ZXJpdHlSZXF1ZXN0GiouaW52ZW50b3J5LnYxLlVwZGF0ZU1hbnVhbFNldmVyaXR5UmVzcG9uc2UiAEK5AQoQY29tLmludmVudG9yeS52MUIRQWxlcnRTZXJ2aWNlUHJvdG9QAVpBZ2l0aHViLmNvbS9sZW1hLmFpL2xlbW1hdGEvYXBpL3Byb3RvL2dlbi9pbnZlbnRvcnkvdjE7aW52ZW50b3J5djGiAgNJWFiqAgxJbnZlbnRvcnkuVjHKAgxJbnZlbnRvcnlcVjHiAhhJbnZlbnRvcnlcVjFcR1BCTWV0YWRhdGHqAg1JbnZlbnRvcnk6OlYxYgZwcm90bzM", [file_inventory_v1_alert, file_inventory_v1_risk, file_inventory_v1_signal_detail]);

/**
 * @generated from message inventory.v1.ListAlertsRequest
 */
export type ListAlertsRequest = Message<"inventory.v1.ListAlertsRequest"> & {
  /**
   * @generated from field: optional string company_id = 1;
   */
  companyId?: string;

  /**
   * @generated from field: repeated inventory.v1.RiskLevel severities = 2;
   */
  severities: RiskLevel[];

  /**
   * @generated from field: repeated inventory.v1.AlertStatus work_statuses = 3;
   */
  workStatuses: AlertStatus[];

  /**
   * Return only open_or_ongoing_count, skipping the alert rows. For tab badges.
   *
   * @generated from field: bool count_only = 4;
   */
  countOnly: boolean;
};

/**
 * Describes the message inventory.v1.ListAlertsRequest.
 * Use `create(ListAlertsRequestSchema)` to create a new message.
 */
export const ListAlertsRequestSchema: GenMessage<ListAlertsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_service, 0);

/**
 * @generated from message inventory.v1.ListAlertsResponse
 */
export type ListAlertsResponse = Message<"inventory.v1.ListAlertsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.Alert alerts = 1;
   */
  alerts: Alert[];

  /**
   * OPEN or ONGOING alerts under the same filters; set only when count_only.
   *
   * @generated from field: int32 open_or_ongoing_count = 2;
   */
  openOrOngoingCount: number;
};

/**
 * Describes the message inventory.v1.ListAlertsResponse.
 * Use `create(ListAlertsResponseSchema)` to create a new message.
 */
export const ListAlertsResponseSchema: GenMessage<ListAlertsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_service, 1);

/**
 * @generated from message inventory.v1.GetAlertRequest
 */
export type GetAlertRequest = Message<"inventory.v1.GetAlertRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.GetAlertRequest.
 * Use `create(GetAlertRequestSchema)` to create a new message.
 */
export const GetAlertRequestSchema: GenMessage<GetAlertRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_service, 2);

/**
 * @generated from message inventory.v1.GetAlertResponse
 */
export type GetAlertResponse = Message<"inventory.v1.GetAlertResponse"> & {
  /**
   * @generated from field: inventory.v1.Alert alert = 1;
   */
  alert?: Alert;

  /**
   * @generated from field: inventory.v1.SignalDetail detail = 2;
   */
  detail?: SignalDetail;
};

/**
 * Describes the message inventory.v1.GetAlertResponse.
 * Use `create(GetAlertResponseSchema)` to create a new message.
 */
export const GetAlertResponseSchema: GenMessage<GetAlertResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_service, 3);

/**
 * @generated from message inventory.v1.UpdateAlertStatusRequest
 */
export type UpdateAlertStatusRequest = Message<"inventory.v1.UpdateAlertStatusRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: inventory.v1.AlertStatus status = 2;
   */
  status: AlertStatus;

  /**
   * @generated from field: optional string comment = 3;
   */
  comment?: string;
};

/**
 * Describes the message inventory.v1.UpdateAlertStatusRequest.
 * Use `create(UpdateAlertStatusRequestSchema)` to create a new message.
 */
export const UpdateAlertStatusRequestSchema: GenMessage<UpdateAlertStatusRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_service, 4);

/**
 * @generated from message inventory.v1.UpdateAlertStatusResponse
 */
export type UpdateAlertStatusResponse = Message<"inventory.v1.UpdateAlertStatusResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateAlertStatusResponse.
 * Use `create(UpdateAlertStatusResponseSchema)` to create a new message.
 */
export const UpdateAlertStatusResponseSchema: GenMessage<UpdateAlertStatusResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_service, 5);

/**
 * @generated from message inventory.v1.UpdateManualSeverityRequest
 */
export type UpdateManualSeverityRequest = Message<"inventory.v1.UpdateManualSeverityRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: inventory.v1.RiskLevel severity = 2;
   */
  severity: RiskLevel;

  /**
   * @generated from field: optional string comment = 3;
   */
  comment?: string;
};

/**
 * Describes the message inventory.v1.UpdateManualSeverityRequest.
 * Use `create(UpdateManualSeverityRequestSchema)` to create a new message.
 */
export const UpdateManualSeverityRequestSchema: GenMessage<UpdateManualSeverityRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_service, 6);

/**
 * @generated from message inventory.v1.UpdateManualSeverityResponse
 */
export type UpdateManualSeverityResponse = Message<"inventory.v1.UpdateManualSeverityResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateManualSeverityResponse.
 * Use `create(UpdateManualSeverityResponseSchema)` to create a new message.
 */
export const UpdateManualSeverityResponseSchema: GenMessage<UpdateManualSeverityResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_service, 7);

/**
 * AlertService is the user-facing surface for alerts. Reads filter to
 * alert_visible = true; mutations touch only the alert-state columns
 * (work_status, manual_severity) — rule engine outputs are never written
 * here, and the per-signal mutations (false-positive marks, comment
 * threads) live on SignalService since both the alert view and the signal
 * view share the same backing entity.
 *
 * @generated from service inventory.v1.AlertService
 */
export const AlertService: GenService<{
  /**
   * @generated from rpc inventory.v1.AlertService.ListAlerts
   */
  listAlerts: {
    methodKind: "unary";
    input: typeof ListAlertsRequestSchema;
    output: typeof ListAlertsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AlertService.GetAlert
   */
  getAlert: {
    methodKind: "unary";
    input: typeof GetAlertRequestSchema;
    output: typeof GetAlertResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AlertService.UpdateAlertStatus
   */
  updateAlertStatus: {
    methodKind: "unary";
    input: typeof UpdateAlertStatusRequestSchema;
    output: typeof UpdateAlertStatusResponseSchema;
  },
  /**
   * Set or clear the per-alert manual severity override. Clearing falls back
   * to winning_rule.engine_severity → signal_type.default_level.
   *
   * @generated from rpc inventory.v1.AlertService.UpdateManualSeverity
   */
  updateManualSeverity: {
    methodKind: "unary";
    input: typeof UpdateManualSeverityRequestSchema;
    output: typeof UpdateManualSeverityResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_alert_service, 0);

